import { Chip } from '@mui/material';
import React from 'react';

import { CenterCellContainer } from './CenterCellContainer';

export const CellChip = ({ value }: { value: string }) => {
  if (!value) {
    return '';
  }
  return (
    <CenterCellContainer>
      <Chip
        label={value}
        className='row-chip'
        size='small'
        sx={{
          fontWeight: '500',
          backgroundColor: (theme) => theme.palette.grey[700],
          color: (theme) => theme.palette.common.white,
        }}
      />
    </CenterCellContainer>
  );
};
